/**
 * @fileOverview The main entry point to your standalone. Start editing here.
 */

import React from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/grid.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/accordion.css'
import './styles.scss'
import './disco_changes.scss'
import { Masthead } from '@ta-interaktiv/react-masthead'
import { Footer } from '@ta-interaktiv/react-footer'
import { ThemeSwitch } from '@ta-interaktiv/react-theme-switch'
import { Link, UpdateNote } from '@ta-interaktiv/contentbricks'
import { ArticleTeasers } from '@ta-interaktiv/react-article-teasers'
import { Accordion } from 'semantic-ui-react'
import Tab from 'components/tab'
import parseHostname from '@ta-interaktiv/parse-hostname'

import { qanda } from './qa'
// console.log(qanda)
// TODO Set the correct article ID here
const ARTICLE_ID = '31762079'
const isMobile = window.innerWidth < 600

export class AppComponent extends React.Component<Props, State> {
  constructor(props) {
    super(props)
    this.state = {
      activeIndex: [-1]
    }
  }

  handleClick = (e, titleProps) => {
    const { index } = titleProps
    const { activeIndex } = this.state
    // const newIndex = activeIndex === index ? -1 : index
    // this.setState({ activeIndex: newIndex })
    const openIndex = activeIndex.indexOf(index)
    console.log('openIndex: ', openIndex)
    if (openIndex === -1) {
      const newArray = this.state.activeIndex.slice()
      newArray.push(index)
      this.setState({ activeIndex: newArray })
    } else {
      const newArray = this.state.activeIndex
      newArray.splice(openIndex, 1)
      this.setState({ activeIndex: newArray })
    }

    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: 'Interactions',
      event_action: 'click',
      event_label: 'toggle tab: ' + titleProps.index
    })
  }

  render() {
    return (
      <div className='index'>
        <Masthead articleId={ARTICLE_ID} />
        <ThemeSwitch />

        {/* TODO Replace the following segment with your project cover */}
        <header className='ui vertical relaxed segment'>
          <div className='ui container'>
            <h1 className='ui image header'>
              <div className='content'>
                Quels masques protègent et comment les porter correctement?
                <div className='sub header lead'>
                  Les masques de protection seront bientôt davantage accessibles
                  et portés en Suisse. Vous trouverez tout ce qu’il faut savoir
                  à ce sujet dans notre grand guide visuel.
                </div>
              </div>
            </h1>
          </div>
        </header>

        {/* TODO And probably remove the following segment and replace it with
       your own content */}
        <div className='ui vertical segment'>
          <div className='ui text container'>
            <UpdateNote
              // updating='Stand'
              current='22 avril 2020'
            />
            <div className='ta author'>
              <strong>
                Patrick Vögeli, Alexandra Bröhm, Sebastian Broschinski, Marc
                Brupbacher
              </strong>
            </div>
            <p>
              Faut-il, oui ou non, porter un masque? Le débat fait rage depuis
              des semaines. De nombreux experts, à l’instar de l'épidémiologiste
              Marcel Salathé, estiment que les masques jouent un rôle important
              pour endiguer l'épidémie. Après tout, de nombreuses personnes
              infectées ne présentent aucun symptôme ou seulement des symptômes
              légers, au point de ne même pas savoir qu'elles sont malades.
              «C’est tout simple: si tout le monde porte un masque, les malades
              en portent un aussi», explique Alexander Kekulé, éminent
              professeur de virologie en Allemagne. Mais d'autres doutent plutôt
              de l'effet. L'Office fédéral de la santé publique (OFSP) a
              longtemps déconseillé de rendre les masques obligatoires. Mais,
              depuis, le problème de pénurie en Suisse a été résolu. «Nous
              partons du principe que le marché mondial fournira de nouveau
              suffisamment de masques», a déclaré Daniel Koch, de l'OFSP, lors
              d'une conférence de presse la semaine dernière. Une majorité de la
              population suisse est d’ailleurs favorable à une obligation
              générale de porter des masques en public, selon un{' '}
              <Link
                href={
                  'https://www.' +
                  parseHostname().publicationDomain +
                  '/20812485'
                }
              >
                sondage
              </Link>{' '}
              réalisé par Tamedia, l’éditeur de ce journal.
            </p>
            <p>
              Mais certains doutent de l'effet d’une telle mesure. L'Office
              fédéral de la santé publique (OFSP) a longtemps déconseillé de
              rendre les masques obligatoires. Depuis, le problème de pénurie en
              Suisse a été résolu. «Nous partons du principe que le marché
              mondial fournira de nouveau suffisamment de masques», a déclaré
              Daniel Koch, de l'OFSP, lors d'une conférence de presse la semaine
              dernière.
            </p>
            <p>
              Voici la bonne nouvelle. La mauvaise, c’est que de nombreuses
              personnes portent ces masques de protection de manière incorrecte.
              Nous montrons ce à quoi il faut faire attention.
            </p>
          </div>
        </div>
        <div className='ui vertical segment'>
          <div className='ui text container'>
            <h3>
              <div className='qnumber'>1</div>Les plus grandes erreurs
            </h3>
            <p style={{ marginBottom: '2rem' }}>
              La plupart des gens supportent rapidement mal le port d’un masque.
              Ils commencent alors à le pincer et à le tirer vers le haut ou
              vers le bas. C’est justement ce qu’il faudrait éviter de faire. Si
              vous décidez de porter un masque, il ne faut pas le toucher une
              fois en place. Si vous continuez à le mettre et à l'enlever sans
              vous désinfecter les mains, autant ne pas en porter. Il n'est pas
              facile de rester discipliné. Mais, lorsqu'ils sont utilisés
              correctement, les masques peuvent constituer une barrière
              importante contre la propagation de la maladie, selon divers
              experts.
            </p>

            <Fails
              direction='left'
              imgSrc='fail_1.png'
              text='Le masque doit toujours couvrir le nez.'
            />
            <Fails
              direction='right'
              imgSrc='fail_2.png'
              text='Le menton doit également toujours être entièrement recouvert.'
            />

            <Fails
              direction='left'
              imgSrc='fail_3.png'
              text='Le masque ne doit pas pendouiller librement au-dessus des oreilles, mais il doit être attaché de façon serrée.'
            />

            <Fails
              direction='right'
              imgSrc='fail_4.png'
              text='Le masque ne doit jamais être placé sous le menton pour soulager la tension.'
            />
          </div>
          {/* <div className='ui vertical segment'> */}
          <div className='ui text container'>
            <div className='smallTitle center'>Voici un port correct!</div>
            <Fails
              direction='center'
              imgSrc='correct.png'
              text='Le masque doit couvrir tout le nez et le menton. Il doit être serré de manière à être proche du visage: il ne faut pas laisser d’espace.'
              correct
            />

            <div className='list'>
              <div className='smallTitle'>Voici ce qu’il faut faire:</div>
              <ul>
                <li>
                  Avant de le mettre, il faut{' '}
                  <Link
                    href={
                      'https://interactif.' +
                      parseHostname().publicationDomain +
                      '/2020/covid-19-bien-laver-les-mains/?nosome'
                    }
                  >
                    se laver les mains
                  </Link>
                  .
                </li>
                <li>
                  Dans le cas d'un masque bicolore, le blanc est à l'intérieur,
                  du côté du visage, le bleu à l'extérieur.
                </li>
                <li>
                  La tige métallique doit être placée en haut, de façon à
                  pouvoir être pincée sur le cartilage nasal et d’épouser la
                  forme du nez. Un masque bien porté ne doit pas faire de buée
                  sur les lunettes.
                </li>
                <li>
                  Il faut ensuite tirer la partie inférieure du masque pour la
                  fixer sous le menton
                </li>
                <li>
                  Une fois mis en place, il faut éviter de le toucher. Si vous
                  le faites, lavez-vous à chaque fois les mains. Le masque
                  devient humide après quelques heures et il faut le changer.
                  Selon l’OFSP, un masque peut être porté jusqu’à huit heures.
                  Le masque s’enlève par derrière: il ne faut pas toucher le
                  devant.
                </li>
                <li>
                  Jetez le masque utilisé dans une poubelle fermée et lavez-vous
                  les mains.
                </li>
              </ul>
            </div>
            <p>
              Ce n'est pas parce que vous portez un masque que vous devez vous
              sentir trop en sécurité. Les règles d'hygiène et la distance
              sociale sont toujours aussi importantes.
            </p>
          </div>
        </div>
        {/* </div> */}
        <div className='ui vertical segment'>
          <div className='ui text container'>
            <h3>
              <div className='qnumber'>2</div>Quels types de masques sont
              disponibles
            </h3>
            <div className='smallTitle'>
              Masques respiratoires (avec et sans valve)
            </div>
            <div className='smallSubtitle'>FFP1, FFP2, FFP3</div>
            <img
              className='masktype'
              src={require('images/atemschutzmaske.jpg')}
            />
            <div className='list'>
              <ul className='maskList'>
                <li>
                  Le sigle FFP signifie filtering face fiece. FFP1, FFP2 et FFP3
                  assurent une protection à 80, 94 et 99% contre les virus.
                </li>
                <li>
                  Avec ces masques, le porteur, par exemple un soignant ou un
                  médecin, se protège contre les infections, car l'air qu'il
                  respire est filtré de l'extérieur avant qu’il ne soit inhalé.
                </li>
                <li>
                  Les filtres à particules capturent également la poussière, les
                  vapeurs ou les micro-organismes.
                </li>
                <li>En principe, il est réservé au personnel médical.</li>
                <li>
                  Attention: les masques FFP avec valves ne protègent pas les
                  autres, car seul l'air inhalé est filtré. Les personnes
                  malades du Covid-19 ne doivent en aucun cas porter ce type de
                  masques.
                </li>
                <li>
                  Les valeurs de protection ne s'appliquent que si le masque est
                  parfaitement adapté, de sorte que même «des poils de barbe sur
                  la ligne d'étanchéité entre le respirateur et la peau du
                  visage peuvent nuire à l'effet protecteur», comme le souligne
                  l'Institut Robert Koch.
                </li>
              </ul>
            </div>
            <div className='smallTitle'>
              Masques d'hygiène ou masque chirurgical
            </div>
            <div className='smallSubtitle'>Type II ou IIR</div>{' '}
            <img
              className='masktype'
              src={require('images/hygienemaske.jpg')}
            />
            <div className='list'>
              <ul className='maskList'>
                <li>
                  Ces masques sont destinés en premier lieu aux personnes
                  présentant des symptômes de maladie. Ils protègent
                  l'environnement contre les agents pathogènes infectieux
                  provenant du nez et de la bouche du porteur. Portés par
                  l’entourage, Ces masques peuvent donc réduire le risque
                  d'infection chez les personnes âgées et les malades
                  chroniques.
                </li>
                <li>
                  Ils n'offrent pas une protection fiable contre les infections
                  car ils ne sont pas équipés de filtre et que beaucoup d'air
                  est aspiré sur les bords.
                </li>
                <li>
                  Ils empêchent toutefois que les muqueuses de la bouche et du
                  nez ne soient touchées par des mains éventuellement
                  contaminées.
                </li>
                <li>
                  Après un usage unique, jetez-les immédiatement et lavez-vous
                  les mains à l'eau et au savon.
                </li>
              </ul>
            </div>
            <div className='smallTitle'>Masques en tissu faits maison</div>
            <img className='masktype' src={require('images/diymaske.jpg')} />
            <div className='list'>
              <ul className='maskList'>
                <li>
                  Si vous ne pouvez pas acheter un masque, vous pouvez aussi le
                  coudre ou le fabriquer vous-même.
                </li>
                <li>
                  Il est préférable d'utiliser un matériau comme le coton, qui
                  peut être lavé à chaud. Idéalement, le masque devrait avoir
                  plusieurs couches.
                </li>
                <li>
                  Certaines tutoriels sur Internet recommandent l’utilisation de
                  sacs d’aspirateurs filtrant les particules. C’est à éviter,
                  car ce matériau n’est pas destiné à filtrer de l’air inhalé et
                  peut contenir des microfibres dommageables pour la santé.
                </li>
                <li>
                  Comme les masques d’hygiène, les masques en tissu ne vous
                  protègent pas vraiment des infections, mais ils protègent
                  votre entourage.
                </li>
                <li>
                  On trouve de nombreux tutoriels sur la façon de fabriquer
                  soi-même un masque. Il y en a même pour ceux{' '}
                  <Link href='https://youtu.be/7Lg0jnJ3hEo'>
                    qui n'aiment pas coudre
                  </Link>
                  !
                </li>
                <li>
                  En France, après la consultation de 150 experts, l’Association
                  française de normalisation (Afnor) publie le 27 mars ses
                  propres{' '}
                  <Link href='https://www.sf2s-sterilisation.fr/wp-content/uploads/2020/04/AFNORSpec-S76-001-MasquesBarrieres-1.pdf'>
                    modèles
                  </Link>{' '}
                  de masques, et l’Académie de médecine recommande le port
                  obligatoire du{' '}
                  <Link href='https://www.lepoint.fr/societe/covid-l-academie-de-medecine-pour-le-port-obligatoire-du-masque-meme-alternatif-03-04-2020-2370000_23.php'>
                    masque «alternatif»
                  </Link>{' '}
                  pour les sorties nécessaires en période de confinement.
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className='ui vertical segment qa'>
          <div className='ui text container'>
            <h3>
              <div className='qnumber'>3</div>Les questions et réponses les plus
              importantes
            </h3>

            <Accordion fluid styled>
              {qanda.map((q, index) => (
                <>
                  {isMobile && (
                    <div className={'qaList' + index}>
                      <Tab
                        activeIndex={this.state.activeIndex}
                        index={index}
                        handleClick={this.handleClick}
                        title={q.q}
                        articleId={ARTICLE_ID}
                      >
                        {/* <div className='question'>{q.q}</div> */}
                        {q.a}
                      </Tab>
                    </div>
                  )}
                  {!isMobile && <QandA q={q} />}
                </>
              ))}
            </Accordion>
          </div>
        </div>
        {/* TODO Add your credits in this component */}
        <Footer
          locale='fr'
          hidePortfolioTeaser
          articleId={ARTICLE_ID}
          mailTo='atm@tamedia.ch'
          questions={[
            'Cet article était-il informatif?',
            'La mise en forme vous plaît-elle?'
          ]}
          credits={[
            [
              'Conception et rélisation',
              'Patrick Vögeli, Alexandra Bröhm, Sebastian Broschinski, Marc Brupbacher'
            ]
          ]}
        >
          <div
            className='ui container'
            style={{ margin: isMobile ? '1.2em 0 3em' : '0 0 3em' }}
          >
            <h4 className='teaser'>Plus d'articles sur le sujet</h4>
            <ArticleTeasers
              numberOfCards='three'
              articleIds={[
                '21868904',
                '30510165',
                '30020998',
                '25480679',
                '16544854',
                '30646838',
                '20218942',
                '29523091',
                '23601396'
              ]}
            />
          </div>
        </Footer>
      </div>
    )
  }
}

const QandA = ({ q }) => (
  <div className='qa'>
    <div className='question'>{q.q}</div>
    <div className='answer'>{q.a}</div>
  </div>
)

const Fails = ({
  direction,
  imgSrc,
  text,
  correct
}: {
  direction: string
  imgSrc: string
  text: string
  correct?: boolean
}) => (
  <>
    <div className={'failWrapper ' + direction}>
      <div className='roundImage'>
        <img src={require('images/' + imgSrc)} />
      </div>

      <div className='text'>
        <div className={correct ? 'correct' : 'wrong'}>
          <i className={correct ? 'icon check' : 'icon times'} />
          {correct ? 'Juste!' : 'Faux!'}
        </div>
        {text}
      </div>
    </div>
  </>
)
